import { ReactNode } from 'react';
import loginImage from '@/assets/images/login/login-side-image.png';

import { OutdatedBrowserNotice } from '@/components/outdated-browser-notice';
import { getOutdatedBrowser } from '@/lib/browser-support';

interface LoginLayoutProps {
  children: ReactNode;
  userAgent?: string;
}

export function LoginLayout({ children, userAgent = navigator.userAgent }: LoginLayoutProps) {
  const showBrowserNotice = getOutdatedBrowser(userAgent) !== null;

  return (
    <main className="min-h-[100dvh] overflow-hidden grid grid-cols-1 md:grid-cols-[minmax(400px,650px)_1fr]">
      {/* Left image panel: hidden on mobile, visible on tablet+ */}
      <div className="relative hidden max-h-screen md:block md:border-r-[12px] md:border-r-air-primary">
        <img src={loginImage} alt="" aria-hidden="true" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-air-primary bg-opacity-15" />
      </div>

      {/* Right content panel - 32px padding on both sides in all breakpoints */}
      <div
        className={`relative flex flex-col justify-center items-center min-h-full px-8 ${showBrowserNotice ? 'pb-20' : ''}`}
      >
        {showBrowserNotice ? (
          <div className="absolute inset-x-8 top-8 hidden md:block">
            <div className="mx-auto w-full max-w-2xl">
              <OutdatedBrowserNotice userAgent={userAgent} />
            </div>
          </div>
        ) : null}
        <div className="w-full max-w-md">{children}</div>
        {showBrowserNotice ? (
          <div className="mt-4 w-full max-w-md md:hidden">
            <OutdatedBrowserNotice userAgent={userAgent} />
          </div>
        ) : null}
        <a
          target="_blank"
          rel="noreferrer noopener"
          href="https://www.airreading.com/privacy-policy"
          className="absolute bottom-6 text-sm text-[#64748B] underline underline-offset-4 font-[16px] leading-[24px] rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          Privacy policy
        </a>
      </div>
    </main>
  );
}
